{
  "automation": {
    "title": "Exploits are forbidden",
    "body": "ANIDEX detected a bot, an AI agent (ChatGPT, Atlas, Comet…), an automated browser or an auto-clicker. Automating booster openings or any other game action is strictly forbidden.",
    "howTo": "To play, open ANIDEX normally in your browser or from the installed app (PWA), and play yourself.",
    "warning": "Any exploit attempt can lead to the removal of the rewards obtained and a permanent account ban.",
    "code": "Code: {{reason}}",
    "reload": "Reload"
  },
  "language": {
    "label": "Language",
    "french": "Français",
    "english": "English"
  },
  "player": {
    "profile": "View {{username}}’s profile"
  },
  "nav": {
    "home": "Home",
    "homeAria": "ANIDEX home",
    "collection": "Collection",
    "boosters": "Boosters",
    "market": "Market",
    "social": "Social",
    "more": "More",
    "menu": "Your game space",
    "openMenu": "Open all game sections",
    "preferences": "Preferences",
    "admin": "Staff area",
    "animes": "Works",
    "fragments": "Fragments",
    "harvest": "Anima harvest",
    "trades": "Trades",
    "atlas": "Player atlas",
    "referral": "Referrals",
    "groups": {
      "play": "Time to play",
      "collection": "Your album",
      "market": "The counter",
      "community": "The community",
      "account": "Your account"
    },
    "purge": "Purge",
    "quests": "Achievements",
    "calendar": "Calendar",
    "friends": "Friends",
    "messages": "Messages",
    "profile": "Profile",
    "premium": "Premium",
    "rules": "Game rules",
    "primary": "Primary navigation",
    "skip": "Skip to content",
    "discord": "Official Discord",
    "level": "Level {{level}}",
    "levelShort": "Lv. {{level}}",
    "maxLevel": "Maximum level",
    "xp": "Experience",
    "profileAria": "{{name}}’s profile, level {{level}}",
    "anima": "Anima balance, open my profile",
    "animaValue": "{{amount}} Anima, open my profile",
    "notifications": "Notifications",
    "notificationsUnread": "Notifications, {{count}} unread",
    "badgeClaim": "to claim",
    "badgeUnread": "unread",
    "badgeTrades": "trades",
    "badgePending": "pending"
  },
  "footer": {
    "tagline": "One album, a whole community.",
    "support": "Keep the adventure going",
    "supportNote": "Premium, without progression advantages.",
    "explore": "Explore ANIDEX",
    "community": "The community",
    "information": "In full transparency",
    "home": "Discover the game",
    "premium": "The Premium offer",
    "friends": "Players",
    "referral": "Invite your friends",
    "discord": "Official Discord",
    "sales": "Premium sales terms",
    "independent": "Independent project. Images and works belong to their rights holders.",
    "label": "Information",
    "rules": "Game rules",
    "terms": "Terms of use",
    "privacy": "Privacy",
    "notice": "Legal notice",
    "cookies": "Cookies",
    "contact": "Contact us",
    "copyright": "© {{year}} ANIDEX — Edwyn Lengrand",
    "note": "The game stays free. Premium is optional. Anima is not money."
  },
  "auth": {
    "signIn": "Sign in"
  },
  "states": {
    "loading": "Loading",
    "loadFailed": "Couldn’t load",
    "retry": "Try again",
    "searchRequired": "Choose what to display",
    "searchRequiredHint": "Search or select a filter to load results.",
    "loadSelectionHint": "Load this selection only when you need it.",
    "nametagFilter": "Label",
    "nametagAll": "All labels"
  },
  "actions": {
    "showSelection": "Show this selection",
    "continue": "Continue",
    "backHome": "Back to home",
    "reload": "Reload",
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "confirm": "Confirm",
    "more": "Show more"
  },
  "pagination": {
    "label": "Pagination",
    "prev": "Previous",
    "next": "Next",
    "page": "Page {{page}}"
  },
  "toasts": {
    "close": "Dismiss notification",
    "achievement": "{{title}}: tier {{tier}} claimed",
    "animeCompleted": "Work completed",
    "achievementReady": "Achievement tier reached!",
    "achievementReadyDetail": "{{title}} · tier {{tier}} to claim"
  },
  "turnstile": {
    "label": "Verification"
  },
  "humanCheck": {
    "title": "Quick check",
    "body": "Every 30 minutes, Cloudflare checks that you are the one playing, not a bot. It takes a few seconds, then your action resumes on its own.",
    "checking": "Checking…"
  },
  "install": {
    "label": "Install the app",
    "later": "Later",
    "iosBefore": "Tap",
    "share": "Share",
    "iosMid": "in Safari, then",
    "addHome": "Add to Home Screen"
  },
  "verify": {
    "banner": "Confirm your email to open boosters and claim rewards. The link is in your inbox.",
    "sent": "Email sent.",
    "resend": "Resend the email"
  },
  "levelUp": {
    "title": "Level {{level}} reached"
  },
  "notFound": {
    "title": "Page not found",
    "intro": "This page doesn’t exist or has moved."
  },
  "routeError": {
    "title": "Something went wrong",
    "intro": "Reload the page. If it keeps happening, try again in a few minutes."
  },
  "rarity": {
    "filter": "Filter by rarity",
    "progress": "Progress by rarity",
    "all": "All"
  },
  "theme": {
    "label": "Theme",
    "auto": "Auto",
    "light": "Day",
    "dark": "Night",
    "option": "{{label}} theme"
  },
  "sound": {
    "on": "Sound on",
    "off": "Sound off",
    "group": "Interface sounds",
    "enabled": "On",
    "muted": "Off"
  },
  "rank": {
    "aria": "Rank {{rank}}"
  },
  "unlocks": {
    "equippedSuffix": ", equipped",
    "show": "Show unlocked cosmetics",
    "hide": "Hide cosmetics",
    "more": "Load more",
    "kinds": {
      "title": "title",
      "badge": "badge",
      "frame": "frame",
      "avatar": "avatar",
      "banner": "banner"
    },
    "groups": {
      "title": "Titles",
      "badge": "Badges",
      "frame": "Frames",
      "banner": "Banners",
      "avatar": "Avatars"
    }
  },
  "rewards": {
    "fragments": "+{{formatted}} fragments",
    "booster_one": "1 {{name}} Booster",
    "booster_other": "{{count}} {{name}} Boosters",
    "character": "{{rarity}} character"
  },
  "time": {
    "daysHours": "{{days}} d {{hours}} h",
    "days_one": "{{count}} d",
    "days_other": "{{count}} d",
    "hours": "{{hours}} h {{minutes}} min",
    "minutes": "{{minutes}} min {{seconds}} s",
    "seconds_one": "{{count}} s",
    "seconds_other": "{{count}} s"
  },
  "meta": {
    "home": {
      "title": "ANIDEX - Collect characters from works",
      "description": "Open boosters, collect more than 180,000 characters from works, complete your series, upgrade your cards, and trade on the market."
    },
    "rules": {
      "title": "Game rules",
      "description": "Understand ANIDEX: boosters, rarities, fragments, upgrades, Anima, the market, auctions, trades, and progression."
    },
    "terms": {
      "title": "Terms of use",
      "description": "Terms of the free ANIDEX game: account, Anima, one account per IP address, and account deletion."
    },
    "privacy": {
      "title": "Privacy policy",
      "description": "Data stored by ANIDEX, the JSON download, and account erasure."
    },
    "notice": {
      "title": "Legal notice",
      "description": "Publisher, contact, and host of ani-dex.app."
    },
    "cookies": {
      "title": "Cookies",
      "description": "The ANIDEX session cookie, local browser storage, and what Cloudflare may set."
    },
    "login": {
      "title": "Sign in",
      "description": "Sign in to ANIDEX to get back to your collection, boosters, and trades."
    },
    "register": {
      "title": "Sign up",
      "description": "Create a free ANIDEX account and start collecting characters from works."
    },
    "verify": {
      "title": "Email verification",
      "description": "Confirm your email address to secure your ANIDEX account."
    },
    "boosters": {
      "title": "Boosters",
      "description": "Open Standard, Premium, or Lucky boosters and pull characters by popularity."
    },
    "purge": {
      "title": "Purge",
      "description": "Sell several cards at once to the system, at a price set from their value."
    },
    "collection": {
      "title": "My collection",
      "description": "Browse your cards, filter by rarity, and upgrade your characters."
    },
    "animes": {
      "title": "Works",
      "description": "Explore works in the ANIDEX catalog and track your completion."
    },
    "quests": {
      "title": "Achievements",
      "description": "Unlock achievements by collecting, opening boosters, and progressing."
    },
    "calendar": {
      "title": "Login calendar",
      "description": "Daily login rewards: Anima, fragments, boosters, and rare characters."
    },
    "harvest": {
      "title": "Anima Harvest",
      "description": "A monthly Anima jackpot, fed by market fees and opened boosters. At the end of the month it is shared according to boosters opened."
    },
    "friends": {
      "title": "Friends",
      "description": "Find fellow collectors, send requests, and follow their activity."
    },
    "atlas": {
      "title": "Atlas",
      "description": "Browse your friends’ visible collections, card by card."
    },
    "messages": {
      "title": "Messages",
      "description": "ANIDEX messages between collectors."
    },
    "notifications": {
      "title": "Notifications",
      "description": "Your market, trade, friend, and progression alerts."
    },
    "profile": {
      "title": "My profile",
      "description": "Collector profile settings on ANIDEX."
    },
    "market": {
      "title": "Card market",
      "description": "Buy and sell cards at a fixed price on the ANIDEX market."
    },
    "auctions": {
      "title": "Auctions",
      "description": "Bid on cards with anti-snipe and buyout."
    },
    "myListings": {
      "title": "My listings",
      "description": "Manage your active listings."
    },
    "myAuctions": {
      "title": "My auctions",
      "description": "The cards you put up for auction."
    },
    "history": {
      "title": "Market history",
      "description": "History of your purchases and sales on the ANIDEX market."
    },
    "trades": {
      "title": "Trades",
      "description": "Offer and accept card trades between players."
    },
    "notFound": {
      "title": "Page not found",
      "description": "This ANIDEX page can’t be found or is no longer available."
    },
    "referral": {
      "title": "Referrals",
      "description": "Invite your friends with your referral code: they get a starter boost."
    }
  }
}
